import { Credits } from "../Credits";
import { StyleOfText } from "../../textStyle";
import { JumpingCoins } from "../../gameLib/JumpingCoin/jumpingCoinMain";
import { BetPopper } from "../../gameLib/betPopper";
import { PopperState } from "../../gamestate/PopperState";
import { AutoplayPopper } from "../../gameLib/autoplayPopper";
// import { API_Abs } from "../../gameLib/api_Abstraction";
import { FreespinMode } from "../../gameLib/FreeSpin/freeSpinModeMain";
import { GambleGame } from "../../gameLib/GambleGame/gambleGame";
import { GameBar } from "../../gameLib/gameUIBar/gameBar";
import { PopupMessageBox } from "../../messageBox";
import { AnimationFrameRate } from "../../gameLib/animationFrameRate";
import {
  jackPotManager,
  jackpotResults,
} from "../../JackpotGame/jackPotManager";
import { GameTextGeneral } from "../GameText";
import { OptionBuilder } from "../../gameLib/Option/OptionBuilder";
import { JackpotData } from "../../JackpotGame/jackpotData";
import { Backgroundsky } from "../../gameLib/bg_sky";
import { Replay } from "../../gameLib/Replay/replayMain";
import { WinAnimation } from "../../gameLib/winAnimation/winAnimationBuilder";
import { getParameterByName } from "../../getParameters";
// import { GamePayTableBuilder } from "../../gameLib/GamePayTableLib/gamePayTable_Class";
import { PortraitMode } from "../../gameLib/PortraitMode/portraitPlayUi";
import { ClockDisplay } from "../../gameLib/clock";
import { logoOverlay } from "../../gameLib/overlayLogo";
import { GamePlayResult, JackpotContext } from "../../gameLib/APIModels/models";
import { Tournament } from "../../gameLib/Tournament/Main_Tournament";
import {
  TournamentParticipation,
  TournamentRanking,
} from "../../gameLib/Tournament/Interfaces_Tournament";
import { TournamentTexts } from "../TournamentText";
import { MobileFloatingButtons } from "../../gameLib/gameUIBar/MobileFloatingButtons";
import { firstTouchAudio } from "../../gameLib/firstTouchAudioPlay";
import { portraitBGCommon } from "../../gameLib/PortraitMode/portraitModeBg";
import { onBetChangeUpDown } from "../../functions/Functions_GameBar";
import { Howl } from "howler";
import { blackScreenCover } from "../../gameLib/blackScreenCover";
import PixiFps from "pixi-fps";
import { BuyBonusMain } from "../../gameLib/Addons/Buy_in/buyInMain";
import { GambleGameNico } from "../../gameLib/GambleGameNico/gambleGameNico";
import { GameRoundDisplay } from "../../gameLib/Addons/gameRoundDisplayOverlay/gameroundDisplayer";
import { CommonConfigData } from "../../localization/gameConfig/gameConfigCommonInterface";
import { skipGame } from "../../functions/Functions_General";
import { EmulationMain } from "../../gameLib/Replay/emulation/emulationMain";
import { AlwaysVisibleGameBlackBar } from "../../gameLib/Addons/blackBarBottomScreenLandscape/alwaysVisibleGameNameDisplayer";
import { generateVersion } from "../../functions/cookies";
import DeviceChecker from "../../functions/helper.ts/DeviceChecker";
import { MinimumStakeDisplayPopup } from "../../gameLib/MiniumStakePopup/miniumStakePopup";
import { Container } from "pixi.js";

// interface PlayerBalance {
import {
  DEFAULT_MARKET_CODE,
  getCommonConfig,
  isValidMarketCode,
} from "../../localization/gameConfig/gameConfigLoader";
import { starLog } from "../../functions/helper.ts/logger";
//***Vars that are common for all games

export abstract class CommonData extends PopperState {
  public initUrl: string;
  public API_handler: any;
  // public API_post:Function;
  public MegaPot: JackpotData;
  public MidiPot: JackpotData;
  public MiniPot: JackpotData;
  public activePlaying: boolean;
  public app: PIXI.Application;
  public autoCountList: Array<number>;
  public autoCountListselected: number;
  public autoPlayTicker: PIXI.ticker.Ticker;
  public autoplayActive: boolean;
  public autoplayPopper: AutoplayPopper;
  public balance: Credits;
  public balanceUpdateAnimationTicker: PIXI.ticker.Ticker;
  public betIndex: number;
  public betList: Array<Credits>;
  public betPopper: BetPopper;
  public betResponse: GamePlayResult;
  public tournamentResponse: TournamentRanking;
  public tournamentScoreResponse: TournamentParticipation;
  public loginResponse: any; //--need to be defined perGame
  public payTableNormal: Array<Array<number>>;
  public payTableBonus: Array<Array<number>>;
  public gamePayTableValues: any; //must be set in Game;
  public GamePayTableBuilder: any;
  public jackpotContext: JackpotContext;
  public betSelected: Credits;

  // public betValue: Credits;
  public bonusBG: boolean;
  public bonusGameMode: boolean;
  public bonusGameModeStarted: boolean;
  public brand: string;
  public cardsize: number;
  public currency: string;
  public currencyPurchases: string;
  // public currentState: string;
  public endpoint: string;
  // public fonta: PIXI.TextStyle;
  // public fontb: PIXI.TextStyle;
  public freeSpinBetIndex: number;
  public freeSpinMode: FreespinMode;
  public freeSpinsActive: boolean;
  public freeSpinsCount: number;
  public freeSpinsCountReceived: number;
  public freeSpinsWinning: number;
  public gambleGame: GambleGame | GambleGameNico;
  public gameBar: GameBar;
  public gameId: number;
  public gameMode: string;
  public gameResize: Function;
  public gameResolution: Array<number>;
  public resolution: number;
  public scaleResolution: number;
  public gameScale: number;
  public gameSceneBG: PIXI.Container;
  public gameScene: PIXI.Container;
  public gameSceneBonus: PIXI.Container;
  public gameSkippable: boolean;
  public gameSkipped: boolean;
  public gameText: any; //defined ingame
  public gameTextGeneral: GameTextGeneral;
  public tournamentText: TournamentTexts;
  public gameVersion: string;
  public infiniteSpin: boolean;
  public isAnimationEnabled: boolean;
  public isBonusMessageVisible: boolean;
  public isFullScreen: boolean;
  public isIphone: boolean;
  public isMobile: boolean;
  // public isMute: boolean;
  public jackPotGameAvailable: boolean = false; // jackpot game manager
  public jackPotGameInstantiated: boolean = false; // jackpot game manager
  public jackPotGame: jackPotManager; // jackpot game manager
  public jackpotValuesData: Array<number>;
  public jackpotResponse: Array<jackpotResults>;
  public jackpotsId: Array<number>;
  public jumpCoin: JumpingCoins;
  public lastReelSuspense: boolean;
  public lowBalance: boolean;
  public maxFPS: number;
  public minFPS: number;
  public msgtotalBET: number;
  public msgtotalLOSE: number;
  public msgtotalWIN: number;
  public musicVolume: number;
  public playTimeHours: number;
  public playTimeSeconds: number;
  public playable: boolean;
  public playerActivityMessageBox: PopupMessageBox;
  public reloadGame: boolean = false;
  public serverAction: any; // GamePlayInput.ActionEnum;
  // public sessionID: string;
  public size: Array<number>;
  public ratio: number;
  public skipAnimation: boolean;
  public stage: PIXI.DisplayObject;
  public gameTextStyle: StyleOfText;
  public token: string;
  // public visualSetting: number;
  public winAnimation: WinAnimation;
  public waitWinlines: boolean;
  public winLength: number;
  public winValue: Credits;
  public renderFrameRate: AnimationFrameRate; //--------
  public betConfirmation: PopupMessageBox;
  public lowBalanceMessage: PopupMessageBox;
  public betTimer: number;
  public lang: string;
  public gameFPS: number;
  public gameOption: OptionBuilder;
  public sound: Howl;
  public bonusGameMusic: Howl;
  public normalGameMusic: Howl;
  public normalGameMusic2: Howl;
  public normalGameMusicOffset: Howl;
  public bonusMusicList: Array<Howl>; //contains all bonus game ,jackpot music etc
  public normalGameMusicList: Array<Howl>; //contains all  normal game music;
  public soundList: Array<Howl> = []; //contains all sound fx
  public defineFunctions: Function;
  public paytable: any; //defined ingame
  public environment: any; //defined ingame
  public background: Backgroundsky;
  public sound_suspenseBuildDrum: Howl;
  public sound_bonusSymbolInReel: Howl;

  //--functions

  public callBackFailMessage: Function; //display on gamebreaking error, a message that requires to restart the game
  public requestNewBalance: Function;
  public setAllowedInputs: Function;
  public resetAllBtns: Function;
  public disableAllBtns: Function;

  public recoverSuccess: Function;
  public recoverFail: Function;
  public collectSuccess: Function;
  public collectFail: Function;
  public playFunction: Function;
  public betSuccess: Function;
  public betFail: Function;

  public requestStakeChange: Function;
  public stakeChangeSuccess: Function;
  public stakeChangeFail: Function;

  public balSuccessUpdate: Function;
  public ratioScaleX: number;
  public keyPress: Function;
  public errorBox: PopupMessageBox;
  public mainGame: any; //defined ingame
  public replay: Replay;
  public emulationMode: EmulationMain;
  public replayFn: Function;
  public replayMode: boolean;
  public skipGame: Function; //for slot game s and dice game
  public cloneBetRepsonse: GamePlayResult;
  public lowBalTickerActive: boolean;
  public updateBalanceOnRecovery: boolean;
  public clearOnReplayOpenClose: Function;
  public errorTypeToDisplay: string;
  public homeURl: string;
  public displayReplayMsg: boolean;
  public closeMsg: Function; //close function for replay and bonus game  need to be defined
  public userActivityMsgDisplay: boolean;
  public isDemo: boolean;
  public isEmulation: boolean = false;
  public isTournament: boolean;
  public tournamentmode: Tournament;
  public playOnPortrait: boolean;
  public enableMobileMode: boolean;
  public gameLoaded: boolean;
  public portraitPlayOffsetTop: number;
  public minRatioForPortraitPlay: number;
  public preSkip: boolean;
  public clock: ClockDisplay;
  public mobilePortraitUI: PortraitMode;
  public displayBonusTotalFn: Function;
  public logo: logoOverlay;
  public displayOptionSmall: boolean; //default true for small option pages on desktop
  public InspectReplay: boolean;
  // public DateDisplayOption:any;
  // public toggleBonusMode:Function;
  //--------
  public firstNullAudio: firstTouchAudio;
  public MobileBtns: MobileFloatingButtons;
  public mobilePortraitBG: PIXI.Sprite;

  public bgGradient: PIXI.Container;
  public bgEnv: PIXI.Container;
  //--
  public isAudioMuted: boolean;
  public isInPortraitMode: boolean;
  public portraitModeBackground: portraitBGCommon;
  public portraitBGSky: PIXI.Sprite;
  public portraitGameScaleEnable: boolean;
  public portraitGameSceneScale: Array<number>;
  public portraitGameSceneOffset: Array<number>;
  public portraitScalemainMask: number;
  public scaleMessageBoxPortrait: number;
  public mainMaskContainer: PIXI.Container;
  public betChangeFunction: Function;

  //--
  public blackScreen: blackScreenCover; //-for messages and main
  public blackScreen2: blackScreenCover; // for the casses like when it need t be displayed after message box is closed it will autoclose the
  public blackScreen_buyIn: blackScreenCover; // for the casses like when it need t be displayed after message box is closed it will autoclose the

  public bonusGameCloseAndResetFn: Function;
  public splashScreenBonusCheck: Function;

  // /--
  public winLinesSwitchSpeed: number; //--default 500
  public enableAutoPlayButton: boolean = true;

  //--message popup v2
  public messageContainerNoClipping: PIXI.Container;
  public messageContainer: PIXI.Container;
  public overlayBonusContainer: PIXI.Container;
  public messageBGContainer: PIXI.Container;
  public blackScreenParent: PIXI.Container;
  public gameTypesList: Array<string>;
  public gameType: string;
  public getGameLoaderRessources: Function;
  public isGame: boolean;
  public brandLogoIndex: number;
  public coinsContainer: PIXI.Container;
  public bonusBuyContainer: PIXI.Container;
  public setGameElementsPortraits: Function;
  public gameSceneMask: PIXI.Graphics;

  //--turbo mode
  public turboModeAllowed: boolean = false;
  public turboEnabled: boolean = false;
  //-
  public totalBonusSymbolVisible: number = 0; //used in sergio and christmas game to count the bonus  symbol appearing in reel to calculate the volume
  //
  //    fps display
  public fpsCounterDisplay: PixiFps = new PixiFps();

  //--bonus buy in
  public BuyBonus: BuyBonusMain;
  public BuyBonusIsClientSideReady: boolean = false; ///--need to be true
  //--portrait bg ui container=
  public PortraitUiContainer: PIXI.Container;
  //  public onBetBuySuccessFunction:Function;//-- this function need to be defined for each game
  public enableNewGambleGameFromNico: boolean = false;

  public isTableGame: boolean = false;
  //--
  public gameRoundDisplayOverlay: GameRoundDisplay;
  public gameMarketID: string;
  public commonConfigData: CommonConfigData;
  //--
  public spinTimeCounter: number = 0;
  //-enable or disable the replay skip to result or not
  public useSpinOnReplayInsteadOfRecovery: boolean = false;

  //-game name in gmae
  public miniBlackBarLandscape: AlwaysVisibleGameBlackBar;
  public gameName: string = "";
  public minimumStakePopup: MinimumStakeDisplayPopup; //-show minimum stake popup or not

  public updateJackpotRtpInfo: Function = () => {
    // Empty function that is called each time jackpot is udpated to update the RTP in game info
  };
  constructor() {
    super();
    this.setGameElementsPortraits = function() {}; //-empty function
    this.isGame = true;
    this.brandLogoIndex = 1; //default  red panda
    this.isInPortraitMode = true;
    this.userActivityMsgDisplay =
      getParameterByName("playerActivity") == "true";

    this.lowBalTickerActive = false;
    this.waitWinlines = false;
    this.closeMsg = function() {};
    this.displayReplayMsg = false;
    this.errorTypeToDisplay = "UNKNOWN";
    this.InspectReplay = false;
    this.recoverFail;
    this.MegaPot = new JackpotData();
    this.MidiPot = new JackpotData();
    this.MiniPot = new JackpotData();
    this.isDemo = false;
    this.isTournament = false;
    this.activePlaying = false;
    this.autoCountList = [];
    this.autoCountListselected = 0;
    this.autoplayActive = false;
    this.balance = new Credits(0);
    this.betList = [];
    this.betResponse = null;
    this.jackpotContext = null;
    // this.betValue = new Credits(0);
    this.bonusBG = false;
    this.bonusGameMode = false;
    this.bonusGameModeStarted = false;
    this.cardsize = 213;
    this.ratio = 0;
    this.displayOptionSmall = true; //default true for small option pages on desktop
    // this.DateDisplayOption={year: 'numeric', month: 'short', day: 'numeric'};

    //   this.diceCounter = 0;
    this.freeSpinBetIndex = 0;
    this.freeSpinsActive = false;
    this.freeSpinsCount = 0;
    this.freeSpinsCountReceived = 0;
    this.freeSpinsWinning = 0;
    //   this.gameFPS = 60;
    this.gameId = 0;
    this.gameScale = 1; //default scale is 1 but 1.2 for mobile
    this.gameVersion = generateVersion();
    this.infiniteSpin = true;
    this.isBonusMessageVisible = false;
    this.isMobile = false;
    this.jackpotValuesData = [];
    this.lowBalance = false;
    this.msgtotalBET = 0;
    this.msgtotalLOSE = 0;
    this.msgtotalWIN = 0;
    this.playable = true;
    this.gameSkipped = true; //initialize as skipped
    this.preSkip = false;
    this.replayMode = false;
    this.serverAction = "BET";
    // this.sessionID = "";
    //   this.skipReelOnFlameAnimation = false;
    this.gameTextStyle = new StyleOfText();
    this.winValue = new Credits(0);

    //----------
    this.gameResolution = [1920, 1080];
    this.resolution = 0;
    this.scaleResolution = 0;
    // this.isMute = false;
    this.isFullScreen = false;
    this.isAnimationEnabled = true;
    this.musicVolume = 0.8; //-
    //   this.soundVolume=1;
    this.maxFPS = 60;
    this.minFPS = 30;
    this.skipAnimation = false;
    this.playTimeHours = 0;
    this.currency = "NULL";
    this.updateBalanceOnRecovery = true; //default true for the game recovery but not for the replay
    this.playOnPortrait = true;
    this.enableMobileMode = true;

    this.gameLoaded = false;
    this.portraitPlayOffsetTop = 400; //250//200;
    this.minRatioForPortraitPlay = 1.46; //1.56//1920/1080;
    this.isAudioMuted = false;

    this.betIndex = 0;
    this.betSelected = this.betList[this.betIndex];

    this.freeSpinsCount = 0;
    this.freeSpinsCountReceived = this.freeSpinsCount; //---
    this.freeSpinBetIndex = 0;
    this.freeSpinsWinning = 0;
    //used to animate the balance and win countdown animation
    this.balanceUpdateAnimationTicker = new PIXI.ticker.Ticker();
    this.gameMode = "normalGame";
    //   this.allDice=this.tileImgName;

    //--default scale of portrait for gameScene mode but can be changed in gameData itself
    this.portraitGameScaleEnable = true;
    this.portraitGameSceneScale = [1.43, 1.4];
    this.portraitGameSceneOffset = [5, 6.1]; //offset in xand y
    this.portraitScalemainMask = 1;
    //predefine functions
    this.scaleMessageBoxPortrait = 1.6;

    this.firstNullAudio = new firstTouchAudio();

    //--
    this.betChangeFunction = onBetChangeUpDown; // (): void => { onBetChangeUpDown( this) };

    //---
    this.gameTypesList = ["SLOT", "DICE", "ROULETTE"];
    this.gameType = this.gameTypesList[0]; //default is a slot game

    //-suspense
    this.sound_suspenseBuildDrum = new Howl({
      html5: DeviceChecker.getInstance().checkIsAppleDevice(),
      src: [
        "sounds/Atmospheric Drum Roll Stinger_01.mp3?" +
          "version=" +
          this.gameVersion,
      ],
      volume: 1,
      sprite: {
        sound: [0, 4220, false],
      },
    });

    this.soundList.push(this.sound_suspenseBuildDrum);

    //-bonus symbol highlight sound
    this.sound_bonusSymbolInReel = new Howl({
      html5: DeviceChecker.getInstance().checkIsAppleDevice(),
      src: ["sounds/Bonus Prize.mp3?" + "version=" + this.gameVersion],
      volume: 1,
      sprite: {
        sound: [0, 2000, false],
      },
    });

    this.soundList.push(this.sound_bonusSymbolInReel);

    this.skipGame = (): void => {
      skipGame(this);
    };
  }

  public addMinimumStakePopupTo = (parentContainer: Container): void => {
    this.minimumStakePopup = new MinimumStakeDisplayPopup(this);

    parentContainer.addChild(this.minimumStakePopup);
    this.minimumStakePopup.x = this.size[0] / 2;
    this.minimumStakePopup.y = this.size[1] / 2;

    this.minimumStakePopup.setPortraitPositionY(this.size[1] / 2);
    this.minimumStakePopup.setLandScapePositionY(this.size[1] / 2 - 165);
  };

  public checkMarket = (): void => {
    this.gameMarketID = getParameterByName("marketId").toLowerCase();

    const rawMarketId = getParameterByName("marketId")?.toLowerCase();
    this.gameMarketID = isValidMarketCode(rawMarketId)
      ? rawMarketId
      : DEFAULT_MARKET_CODE;

    this.commonConfigData = getCommonConfig(this.gameMarketID);
    this.enableAutoPlayButton = this.commonConfigData?.autoplayEnabled ?? false;

    console.log(
      "market set to:",
      this.gameMarketID,
      "autoplayEnabled:",
      this.enableAutoPlayButton
    );
    starLog("current Config:", this.commonConfigData);
  };
  public checkCanPlayOnPortrait = (): void => {
    this.playOnPortrait = true;
    if (this.isMobile) {
      let screenRatio = window.innerHeight / window.innerWidth;
      let orientationPortrait = window.matchMedia("(orientation: portrait)")
        .matches;

      if (orientationPortrait) {
        screenRatio = window.innerHeight / window.innerWidth;
      } else {
        screenRatio = window.innerWidth / window.innerHeight;
      }
      if (this.playOnPortrait) {
        if (window.innerHeight > window.innerWidth) {
          screenRatio = window.innerHeight / window.innerWidth;
        }
        if (screenRatio < this.minRatioForPortraitPlay) {
          this.playOnPortrait = false;
        }
      }
    } else {
      this.playOnPortrait = false;
    }

    // console.log(  this.playOnPortrait)
  };
  public tournamentUpdateScore = (): void => {
    //update score on collect
    if (this.isTournament) {
      this.tournamentmode.requeServerForScore();
    }
  };
}
